import React from 'react';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative w-32 h-32 mb-6">
        {/* Outer rotating ring */}
        <div className="absolute inset-0 border-4 border-blue-200 rounded-full animate-spin border-t-primary"></div>
        
        {/* Inner pulsing circle */}
        <div className="absolute inset-4 bg-gradient-to-br from-primary to-blue-600 rounded-full flex items-center justify-center animate-pulse">
          {/* Bitcoin symbol */}
          <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.68-1.93h.01zm-3.01 4.22c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"/>
          </svg>
        </div>
        
        {/* Animated dots around the circle */}
        <div className="absolute inset-0 animate-spin" style={{ animationDuration: '3s' }}>
          <div className="absolute top-0 left-1/2 w-2 h-2 bg-primary rounded-full -ml-1"></div>
          <div className="absolute bottom-0 left-1/2 w-2 h-2 bg-primary rounded-full -ml-1"></div>
          <div className="absolute top-1/2 left-0 w-2 h-2 bg-primary rounded-full -mt-1"></div>
          <div className="absolute top-1/2 right-0 w-2 h-2 bg-primary rounded-full -mt-1"></div>
        </div>
      </div>
      
      {/* CryptoCashFast branding */}
      <div className="text-center">
        <h3 className="text-2xl font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent mb-2">
          CryptoCashFast
        </h3>
        <p className="text-gray-600 animate-pulse">{message}</p>
      </div>
      
      {/* Loading bar */}
      <div className="w-64 h-1 bg-gray-200 rounded-full mt-4 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-primary to-blue-600 rounded-full animate-loading-bar"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
